import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Toggle from "react-toggle";

//import { Test } from './ConfigurationBar.styles';

const ConfigurationBar = ({ highlight, daysAgo, settings, toggleLayout, toggleJukebox, toggleJukeboxAutoPlay, checkRecent }) => {
  const [open, setOpen] = useState(false);
  const inputEl = useRef(null);
  const history = useHistory();

  const handleClose = () => {
    setOpen(false);
  };

  const handleClick = (e) => {
    if (inputEl.current.contains(e.target)) return true;
    handleClose();
  };

  useEffect(() => {
    window.addEventListener("mousedown", handleClick, false);
    // will be called on component unmount
    return () => {
      window.removeEventListener("mousedown", handleClick, false);
    };
  }, []);

  return (
    <div ref={inputEl} className={highlight ? "ConfigurationBar ConfigurationBar-highlight" : "ConfigurationBar ConfigurationBar-regular"}>
      {/* <button onClick={() => history.push("/discover")} title="Discover New Music">
        <FontAwesomeIcon icon="magic" className="cubes fa fa-magic" />
      </button> */}
      <button onClick={() => history.push("/shuffle")} title="Shuffle">
        <FontAwesomeIcon icon="random" className="cubes fa fa-random" />
      </button>
      {daysAgo === 0 && (
        <button onClick={checkRecent} title="Check for new tracks">
          <FontAwesomeIcon icon="sync" className="cubes fa fa-sync" />
        </button>
      )}

      <button onClick={() => setOpen(!open)}>
        <FontAwesomeIcon icon="cog" className="cubes fa fa-cog" />
      </button>

      {open && (
        <div className="home-settings-open">
          <Row>
            <Col xs={4}>
              <label>
                <Toggle id="view-col" defaultChecked={settings.trackUiCols} icons={false} onChange={toggleLayout} />
              </label>
            </Col>
            <Col xs={8} className="text-right setting-text">
              <label htmlFor="view-col"> Column View</label>
            </Col>
          </Row>
          <Row>
            <Col xs={4}>
              <label>
                <Toggle id="play-jukebox" defaultChecked={settings.playInJukebox} icons={false} onChange={toggleJukebox} />
              </label>
            </Col>
            <Col xs={8} className="text-right setting-text">
              <label htmlFor="play-jukebox">Play Tracks in Jukebox</label>
            </Col>
          </Row>
          <Row>
            <Col xs={4}>
              <label>
                <Toggle
                  id="autoplay-jukebox"
                  disabled={!settings.playInJukebox}
                  defaultChecked={settings.autoplayInJukebox}
                  icons={false}
                  onChange={toggleJukeboxAutoPlay}
                />
              </label>
            </Col>
            <Col xs={8} className="text-right setting-text">
              <label htmlFor="autoplay-jukebox">Jukebox auto-play</label>
            </Col>
          </Row>
        </div>
      )}
    </div>
  );
};

ConfigurationBar.propTypes = {
  // bla: PropTypes.string,
};

ConfigurationBar.defaultProps = {
  // bla: 'test',
};

export default ConfigurationBar;
